import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/undraw_no_data.svg'


const _withScopeId = n => (_pushScopeId("data-v-1b1aa802"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-desktop" }
const _hoisted_2 = { class: "colored-bg full-width" }
const _hoisted_3 = {
  key: 0,
  class: "container"
}
const _hoisted_4 = {
  class: "flex-desktop",
  style: {"justify-content":"space-between","align-items":"center"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Check-ins"),
  /*#__PURE__*/_createElementVNode("p", null, "List of your latest check-ins")
], -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "image"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ion-text-center" }, [
  /*#__PURE__*/_createTextVNode(" You haven't"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" scanned anyone yet! ")
], -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "scan-wrapper"
}
const _hoisted_13 = { class: "container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Attendance status", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Latest scan", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scan-box" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Scan QR code", -1))

import { close, qrCode } from "ionicons/icons";
import { useContextStore } from "@/stores/context";
import { BarcodeScanner } from "@capacitor-community/barcode-scanner";
import { QrcodeStream } from "vue-qrcode-reader";
import {
  IonContent,
  IonPage,
  IonFab,
  IonProgressBar,
  IonFabButton,
  IonModal,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
} from "@ionic/vue";
import { reactive, computed, ref } from "vue";
import { getVisitors } from "@/api/visitors";
import {
  getSessions,
  sessionRegistrationCreate,
  sessionEntranceCreate,
  getSessionRegistrations,
} from "@/api/sessions";
import UserCard from "@/views/_partials/UserCard.vue";
import { IVisitor } from "@/models/visitor";
import router from "@/router";
import { useAppStore } from "@/stores/app";
import { useCheckinStore } from "@/stores/check-in";
import { useToasters } from "@/composition/toasters";
import { ISession, ISessionRegistration } from "@/models/session";
import { handleError } from "@/views";
import EventSidebar from "@/views/_partials/EventSidebar.vue";
import { useWindowWidth } from "@/composition/window";
import { event as gtag_event } from "vue-gtag";


export default /*#__PURE__*/_defineComponent({
  __name: 'Scan',
  setup(__props) {

const { isMobile } = useWindowWidth();

const contextStore = useContextStore();
const appStore = useAppStore();
const checkInStore = useCheckinStore();
const toasters = useToasters();

const modal = ref(null as any);

const state = reactive({
  scanActive: false,
  loading: false,
  checkInRegistration: undefined as ISessionRegistration | undefined,
  webScannerOpened: false,
  currentVisitorId: 0 as number | undefined,
  toastButtons: [
    {
      text: "SEE",
      role: "cancel",
      handler: () => {
        router.push(
          `/event/${contextStore.event.id}/visitor/${state.currentVisitorId}`
        );
      },
    },
  ],
});

const visitors = computed(() =>
  checkInStore.visitors.filter(
    (visitor) => visitor.event === contextStore.event.id
  )
);

const checkPermission = async () => {
  const status = await BarcodeScanner.checkPermission({ force: true });
  if (status.granted) {
    return true;
  } else {
    const new_permission = await BarcodeScanner.checkPermission({ force: true });
    return new_permission.granted;
  }
};

const onDecode = (decodedString: any) => {
  checkInVisitor(decodedString.rawValue);
  stopWebScanner();
};

const startWebScanner = () => {
  state.webScannerOpened = true;
};

const stopWebScanner = () => {
  state.webScannerOpened = false;
};

const startScanner = async () => {
  const allowed = await checkPermission();

  if (allowed) {
    document.querySelector('body')?.classList.add("scanner-active");
    BarcodeScanner.hideBackground();
    state.scanActive = true;

    const result = await BarcodeScanner.startScan();

    if (result.hasContent) {
      if (result.content) {
        checkInVisitor(result.content);
      }
    } else {
      toasters.addError("Failed to scan QR code");
    }
  } else {
    toasters.addError("Failed to obtain permissions to launch camera");
  }
};

const stopScanner = () => {
  document.querySelector('body')?.classList.remove("scanner-active");
  BarcodeScanner.stopScan();
  state.scanActive = false;
};

const addEnteredVisitor = (visitor: IVisitor) => {
  checkInStore.add(visitor);

  toasters.addSuccess(`Visitor ${visitor.name} scanned successfuly`);

  if (contextStore.event.checked_in_visitors === 1) {
    gtag_event("first_visitor_scanned", {
      category: "check-in app",
      label: "First visitor scanned",
    });
  }

  contextStore.addEventCheckin();
  state.loading = false;

  if (appStore.settings.checkin_mode === "slow") {
    router.push(`/event/${contextStore.event.id}/visitor/${visitor.id}`);
  } else {
    startScanner();
  }
};

const makeVisitorEntered = (visitor: IVisitor, session: ISession) => {
  sessionEntranceCreate({
    attending: visitor.id || 0,
    session: session.id,
  })
    .then(() => {
      addEnteredVisitor(visitor);
    })
    .catch((err) => {
      state.loading = false;

      if (Array.isArray(err.response.data)) {
        toasters.addError(err.response.data[0]);
        startScanner();
      } else if (Array.isArray(err.response.data._errors)) {
        toasters.addError(err.response.data._errors[0].message);
      } else {
        handleError(err);
      }
    });
};

const checkInVisitor = async (register_code: string) => {
  state.loading = true;
  getVisitors({
    event: contextStore.event.id,
    register_code: register_code,
  })
    .then(async (response) => {
      const visitor = response.data.results[0];

      if (visitor) {
        const responseSessions = await getSessions({
          event: contextStore.event.id,
          search: "check-in",
        });

        state.currentVisitorId = visitor.id;

        const session = responseSessions.data?.results[0];

        getSessionRegistrations({
          event: contextStore.event.id,
          visitor: visitor.id,
          session: session.id,
        })
          .then((response) => {
            state.checkInRegistration = response.data.results[0];
            // Check if this user exists and if it has entered status
            if (
              state.checkInRegistration &&
              state.checkInRegistration.status === 2
            ) {
              toasters.addWarning(
                `The guest ${visitor.name} is already inside.`,
                state.toastButtons
              );
              stopScanner();
              startScanner();
            } else {
              if (session && visitor.id) {
                sessionRegistrationCreate({
                  attending: visitor.id,
                  session: session.id,
                })
                  .then(() => {
                    makeVisitorEntered(visitor, session);
                  })
                  .catch((err) => {
                    state.loading = false;
                    makeVisitorEntered(visitor, session);
                    toasters.addError(err.response.data._errors[0].message);
                  });
              } else {
                state.loading = false;
                toasters.addError("Check-in session was not found");
                startScanner();
              }
            }
          })
          .catch(() => {
            state.loading = false;
          });
      }
    })
    .catch((err) => {
      if (Array.isArray(err.response.data)) {
        toasters.addError(err.response.data[0]);
        startScanner();
      } else if (Array.isArray(err.response.data._errors)) {
        toasters.addError(err.response.data._errors[0].message);
      } else {
        handleError(err);
      }
    });
};

const cardConfig = (visitor: IVisitor) => {
  return {
    name: visitor.name,
    detail: visitor.email,
    picture: visitor.profile_picture,
  };
};

router.beforeEach(() => {
  if (state.scanActive) {
    stopScanner();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!_unref(isMobile))
              ? (_openBlock(), _createBlock(EventSidebar, {
                  key: 0,
                  event: _unref(contextStore).event
                }, null, 8, ["event"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              (!state.scanActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      (!_unref(isMobile))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (!state.scanActive)
                              ? (_openBlock(), _createBlock(_unref(IonFabButton), {
                                  key: 0,
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (startWebScanner())),
                                  color: "success"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonIcon), { icon: _unref(qrCode) }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (state.scanActive)
                              ? (_openBlock(), _createBlock(_unref(IonFabButton), {
                                  key: 1,
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (stopScanner())),
                                  color: "light"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonIcon), { icon: _unref(close) }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visitors.value, (visitor, index) => {
                      return (_openBlock(), _createBlock(UserCard, {
                        user: cardConfig(visitor),
                        route: `/event/${_unref(contextStore).event.id}/visitor/${visitor.id}`,
                        key: `visitor-${index}`
                      }, null, 8, ["user", "route"]))
                    }), 128)),
                    (visitors.value.length === 0)
                      ? (_openBlock(), _createElementBlock("figure", _hoisted_7, _hoisted_11))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("section", null, [
                        _createVNode(_unref(IonGrid), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonRow), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonCol), { size: "6" }, {
                                  default: _withCtx(() => [
                                    _hoisted_14
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(IonCol), { size: "2" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("small", null, _toDisplayString(_unref(contextStore).event.checked_in_visitors) + " of " + _toDisplayString(_unref(contextStore).event.registered_visitors), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(IonCol), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonProgressBar), {
                                      style: {"margin-top":"0.6rem"},
                                      value: 
                          _unref(contextStore).event.checked_in_visitors /
                          _unref(contextStore).event.registered_visitors
                        
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (visitors.value[0])
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_15,
                              _createVNode(UserCard, {
                                route: `/event/${_unref(contextStore).event.id}/visitor/${visitors.value[0].id}`,
                                user: cardConfig(visitors.value[0])
                              }, null, 8, ["route", "user"])
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _hoisted_16
                  ]))
            ])
          ])
        ]),
        _: 1
      }),
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonFab), {
            key: 0,
            vertical: "bottom",
            horizontal: "center",
            slot: "fixed"
          }, {
            default: _withCtx(() => [
              (!state.scanActive)
                ? (_openBlock(), _createBlock(_unref(IonFabButton), {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (startScanner())),
                    color: "success"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), { icon: _unref(qrCode) }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (state.scanActive)
                ? (_openBlock(), _createBlock(_unref(IonFabButton), {
                    key: 1,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (stopScanner())),
                    color: "light"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), { icon: _unref(close) }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonModal), {
        ref_key: "modal",
        ref: modal,
        "keep-contents-mounted": false,
        "is-open": state.webScannerOpened,
        onDidDismiss: stopWebScanner
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _hoisted_17,
            (state.webScannerOpened)
              ? (_openBlock(), _createBlock(_unref(QrcodeStream), {
                  key: 0,
                  onDetect: onDecode
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_button, {
              color: "danger",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (stopWebScanner())),
              style: {"position":"relative","bottom":"150px","left":"260px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

})